import React, { useEffect, useRef } from "react"
import { useIntersection, usePrevious } from "react-use"
import { BarLoader } from "react-spinners"
import colors from "src/config/color"
import styles from "./index.module.scss"

type Props = {
  loadMore: () => void
  isLoading: boolean
  autoLoadOnScroll: boolean
}

export const LoadMoreButton: React.FC<Props> = ({
  isLoading,
  loadMore,
  autoLoadOnScroll = false,
}) => {
  const intersectionRef = useRef<HTMLDivElement | null>(null)
  const intersection = useIntersection(intersectionRef, {})
  const prevIntersection = usePrevious(intersection)

  useEffect(() => {
    if (
      autoLoadOnScroll &&
      intersection?.isIntersecting &&
      !prevIntersection?.isIntersecting
    ) {
      loadMore()
    }
  }, [autoLoadOnScroll, intersection, prevIntersection, loadMore])

  return (
    <div className={styles.loadMore} ref={intersectionRef}>
      {isLoading ? (
        <div className={styles.loadMore_barLoader}>
          <BarLoader color={colors.spectrum.tieupTheme} />
        </div>
      ) : (
        <div className="p-button">
          <button
            className="c-button-secondary -outline -full"
            onClick={loadMore}
          >
            もっと見る
          </button>
        </div>
      )}
    </div>
  )
}
